<template>
  <v-list>
    <v-divider />
    <!-- Opportunities -->
    <v-list-tile
      v-if="user && !user.isSuspended"
      key="opportunities"
      :to="
        location
          ? `/opportunities?center=${location.lat},${location.lon}`
          : '/opportunities'
      "
      @click="toggleIfSmall"
      :active-class="themes.candidate.light.link"
    >
      <v-list-tile-action>
        <v-tooltip right>
          <v-icon slot="activator" medium>mdi-magnify</v-icon>
          <span>Search for Opportunities</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Opportunities Search</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <!-- Profile -->
    <v-list-tile
      key="profile"
      to="/candidate/profile"
      @click="toggleIfSmall"
      :active-class="themes.candidate.light.link"
    >
      <v-list-tile-action>
        <v-tooltip right>
          <v-icon slot="activator" medium>mdi-account</v-icon>
          <span>My Profile</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>My Profile</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-list-tile-action-text>
          <router-link
            to="/candidate/profile#view"
            class="profile-view-link"
            aria-label="View profile preview"
            @click.native.stop="toggleIfSmall"
          >
            <v-tooltip left>
              <v-icon slot="activator" medium>mdi-eye</v-icon>
              <span>Preview</span>
            </v-tooltip>
          </router-link>
        </v-list-tile-action-text>
      </v-list-tile-action>
    </v-list-tile>

    <!-- Documents -->
    <v-list-tile
      key="documents"
      to="/candidate/documents"
      @click="toggleIfSmall"
      :active-class="themes.candidate.light.link"
    >
      <v-list-tile-action>
        <v-tooltip right>
          <v-icon slot="activator" medium>mdi-file</v-icon>
          <span>My Documents</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>My Documents</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <!-- Dashboard -->
    <v-list-tile
      key="dashboard"
      to="/dashboard"
      @click="toggleIfSmall"
      :active-class="themes.candidate.light.link"
    >
      <v-list-tile-action>
        <v-tooltip right>
          <v-icon slot="activator" medium>mdi-clipboard-text</v-icon>
          <span>My Applications</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>My Applications</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <!-- Messages -->
    <v-list-tile
      v-if="chats[0]"
      key="messages"
      to="/candidate/messages"
      @click="toggleIfSmall"
      :active-class="themes.candidate.light.link"
    >
      <v-list-tile-action>
        <v-tooltip right>
          <v-badge right slot="activator" v-if="unread.length">
            <span slot="badge">{{ unread.length }}</span>
            <v-icon medium>mdi-message</v-icon>
          </v-badge>
          <v-icon medium v-else slot="activator">mdi-message</v-icon>
          <span>Messages</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Messages</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <!-- Settings / Account -->
    <v-list-tile
      exact
      key="account"
      to="/candidate/account"
      @click="toggleIfSmall"
      :active-class="themes.candidate.light.link"
    >
      <v-list-tile-action>
        <v-tooltip right>
          <v-icon slot="activator" medium>mdi-cogs</v-icon>
          <span>Settings</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Settings</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <!-- Log out -->
    <v-list-tile
      @click.stop="$emit('logOut')"
      :active-class="themes.candidate.light.link"
    >
      <v-list-tile-action>
        <v-tooltip right>
          <v-icon slot="activator" medium>mdi-logout</v-icon>
          <span>Log out</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Log out</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
// Helpers
import { mapGetters } from "vuex";

// Vue Component
export default {
  props: { location: { type: Object, default: null } },
  created() {
    this.$store.dispatch("candidate/chats/fetchAll");
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      chats: "candidate/chats/all",
    }),
    unread() {
      return this.chats.filter(
        (chat) => chat.readAt === null && chat.senderType != "Candidate"
      );
    },
  },
  methods: {
    toggleIfSmall() {
      if (this.$vuetify.breakpoint.smAndDown) this.$store.commit("closeDrawer");
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-view-link {
  font-size: 11px;
  text-decoration: underline;
}
</style>
